// Terminologia por vertical — equivalente ao namespace `contexts` do app legado.
// A entidade atendida é, por padrão, "Cliente" (termo canônico do produto);
// cada vertical pode reescrever (medicina → "Paciente", educação → "Aluno"…).
// Nenhum componente crava o termo: todos leem de useTerms() (src/i18n).

export interface Terms {
  subject: string
  subjectLower: string
  subjectPlural: string
  subjectPluralLower: string
  /** rótulo do modelo de jornada — genérico por padrão, "Tipo de exame" em medicina */
  template: string
  templateLower: string
}
export interface Vertical { label: string; terms: Terms }

export const VERTICALS: Record<string, Vertical> = {
  generico: {
    label: 'Cliente',
    terms: {
      subject: 'Cliente', subjectLower: 'cliente', subjectPlural: 'Clientes', subjectPluralLower: 'clientes',
      template: 'Modelo de atendimento', templateLower: 'modelo de atendimento',
    },
  },
  medicina: {
    label: 'Paciente',
    terms: {
      subject: 'Paciente', subjectLower: 'paciente', subjectPlural: 'Pacientes', subjectPluralLower: 'pacientes',
      template: 'Tipo de exame', templateLower: 'tipo de exame',
    },
  },
}
export const DEFAULT_VERTICAL = 'generico'
